module.exports = __webpack_public_path__ + "static/Vijayan-Srinivasan-45baffc3ed725656655e1d00ffe2fd35.png";